import { render } from "./TableActionsColumnWrapper.vue?vue&type=template&id=42a0da56"
import script from "./TableActionsColumnWrapper.vue?vue&type=script&lang=js"
export * from "./TableActionsColumnWrapper.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./TableActionsColumnWrapper.vue?vue&type=style&index=0&id=42a0da56&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script